export const RESULT_MAPPING_KEY = 'perspective.result-mapping.';
export const TRACKING_KEY = 'perspective.tracking-preferences.';

/**
 * Values that fill placeholders in funnel content — the visitor's own answers plus any
 * `ps_*` / `utm_*` values seeded from the URL, interpolated into text, HTML blocks and
 * outbound links.
 *
 * Named `perspective.tracking-properties.` until 2.1.34. It never held tracking state: the
 * store exists so a value the visitor supplied can be shown back to them later in the
 * funnel, and the cookie policy has always described it that way.
 */
export const PLACEHOLDERS_KEY = 'perspective.placeholders.';

/**
 * Former names of `PLACEHOLDERS_KEY`, newest first. Read once and migrated away, never
 * written — see `seedTrackingPropertiesFromQuery`. `perspective.personalization.` never
 * shipped, so it only exists in tabs that were open against a staging build; it is listed
 * anyway because the migration costs nothing. Safe to delete once no open tab can still be
 * running a build older than 2.1.34.
 */
export const LEGACY_PLACEHOLDER_KEYS = [
    'perspective.personalization.',
    'perspective.tracking-properties.',
];

export const SPLIT_TESTING_KEY = 'perspective.split-testing-variant.';

export const USER_ID_KEY = 'perspective__user__id';
export const COLOR_LIGHT = '#F5F5F5';
export const COLOR_DARK = '#2A2A2A';
export const TRANSITION_DELAY = 100;
export const OTP_COOLDOWN = 25; // in seconds
export const OTP_VERIFICATION_DELAY = 2000; // in milliseconds
export const OTP_CONSECUTIVE_DELAY = 500; // in milliseconds
export const EXTERNAL_REDIRECT_TIMEOUT = 400; // in milliseconds

export const PREVIEW_MODE = import.meta.env.VITE_PREVIEW_MODE === 'true';
export const PREVIEW_CONTAINER_ID = 'perspective-frame-container';
export const PREVIEW_FRAME_ROOT = 'perspective-frame-root';
export const DISABLED_IN_PREVIEW = 'disabled_in_preview';

/**
 * CLO-2097: the funnel session id, mirrored into localStorage so a visit survives losing its
 * browsing context — an in-app WebView restored after an app switch comes back with
 * localStorage intact and sessionStorage empty.
 *
 * The session's other keys stay local to `TrackingSession`; this one is shared because
 * `purgeTrackingArtifacts` has to remove it on a rejection, and a prefix those two disagreed
 * about would break that silently.
 *
 * Written and read only with granted consent, and only once the visit is past the entry page
 * — see `TrackingSession.writeResumePointer`.
 */
export const RESUME_PREFIX = 'perspective_campaign_session_resume_';
